import { TRANSLATION_KEYS } from '@core/internationalization/translations_keys';
import { ImgI } from '@shared/components/landing/landing.component';
import dayjs from 'dayjs';

export interface ReleaseInfoDTO {
    id: number;
    image: string;
    title: string;
    version: string;
    description: string;
    text: string;
    /** Optional Spanish translations. When the active locale is `es` and the
     *  `_es` field is non-empty, it wins over the English original. */
    title_es?: string | null;
    description_es?: string | null;
    text_es?: string | null;
    released_at: string;
}

/** Pick the Spanish translation when locale is `es` AND the translation is
 *  present (non-empty). Otherwise fall back to the English original. */
function pickLocalized(en: string, es: string | null | undefined, lang: string): string {
    if (lang === 'es' && es && es.trim().length > 0) return es;
    return en ?? '';
}

export type ReleaseInfoNewDTO = {
    release: ReleaseInfoDTO;
    image?: File;
};

export type NewsletterCardI = {
    title: string;
    description: string;
    imgData: ImgI;
    imgIconData: ImgI;
    callToAction: string;
    releaseDate: string;
    text: string;
};
export class NewsletterPost implements NewsletterCardI {
    id: number;
    title: string;
    titleClean: string;
    version: string;
    description: string;
    imgData: ImgI;
    imgIconData: ImgI;
    callToAction: string;
    releaseDate: string;
    releasedAt: string;
    text: string;

    constructor(dto: ReleaseInfoDTO, lang = 'en') {
        const localizedTitle = pickLocalized(dto.title, dto.title_es, lang);
        const localizedDescription = pickLocalized(dto.description, dto.description_es, lang);
        const localizedText = pickLocalized(dto.text, dto.text_es, lang);

        this.title = `${dto.version} # ${localizedTitle}`;
        this.titleClean = localizedTitle;
        this.version = dto.version;
        this.description = localizedDescription;
        this.imgData = {
            src: dto.image,
            alt: localizedTitle,
        };
        this.imgIconData = {
            src: '/assets/favicon/favicon.png',
            alt: 'Twinny logo',
        };
        this.callToAction = TRANSLATION_KEYS.dashboard.newsletter.learnMore;
        this.releaseDate = dayjs(dto.released_at).format('MMMM DD, YYYY');
        this.releasedAt = dto.released_at;
        this.id = dto.id;
        this.text = localizedText;
    }
}
